export const formatCurrency = (val: number) => new Intl.NumberFormat('en-GB').format(
  val,
) + ' USDT';
